import logger from '@/utils/logger';
/**
 * Debug Logger - Production-safe console logging
 * Only logs in development mode to avoid console spam in production
 */

const IS_DEV = import.meta.env.DEV;

export const debugLog = (...args: any[]) => {
  if (IS_DEV) {
    logger.log(...args);
  }
};

export const debugWarn = (...args: any[]) => {
  if (IS_DEV) {
    logger.warn(...args);
  }
};

export const debugError = (...args: any[]) => {
  // Toujours logger les erreurs (même en prod)
  logger.error(...args);
};

export const debugInfo = (...args: any[]) => {
  if (IS_DEV) {
    console.info(...args);
  }
};

// Pour les logs groupés (collapse dans la console)
export const debugGroup = (label: string, fn: () => void) => {
  if (IS_DEV) {
    console.group(label);
    fn();
    console.groupEnd();
  }
};

export default {
  log: debugLog,
  warn: debugWarn,
  error: debugError,
  info: debugInfo,
  group: debugGroup,
};






